import React, { useEffect } from 'react'
import styled from 'styled-components'

const SnackBar = styled.div`
  font-family: 'Proxima-Nova';
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  visibility: hidden;
  min-width: 300px;
  background-color: #000;
  color: white;
  text-align: center;
  padding: 16px;
  border-radius: 8px;
  position: fixed;
  z-index: 1000;
  left: 50%;
  bottom: 30px;
  transform: translateX(-50%);
  transition: visibility 0s, opacity 0.5s ease-in-out;
  opacity: 0;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.06),
    0px 12px 32px 0px rgba(35, 41, 54, 0.14);

  &.show {
    visibility: visible;
    opacity: 1;
  }
`

const Snackbar = ({ message, show, onClose }) => {
  useEffect(() => {
    if (show) {
      const timer = setTimeout(onClose, 3000) // auto-hide after 3 sec
      return () => clearTimeout(timer)
    }
  }, [show, onClose])

  return <SnackBar className={show ? 'show' : ''}>{message}</SnackBar>
}

export default Snackbar
